<template>
    <div class="tags-input-container">
        <div class="tag" v-for="(tag, index) in tags" :key="'tag'+index">
          <span v-if="activeTag !== index" @click="activeTag = index">{{ tag }}</span>
          <input v-else 
                v-model="tags[index]" 
                v-focus 
                :style="{'width': tag.length + 'ch'}" 
                @keyup.enter="activeTag = null" 
                @blur="activeTag = null" />
          <span @click="removeTag(index)"><i class="fas fa-times-circle"></i></span>
        </div>
        <input v-model="tagValue" @keyup.enter="addTag">
    </div>
  </template>
  
  <script>
    export default {
      data: () => {
        return {
          tagValue: '',
          tags: [],
          activeTag: null
        }
      },
      methods: {
        validate(url) {  
          var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/; 
          if (pattern.test(url)) { 
            //  alert("Url is valid"); 
              return true; 
          }  
            //  alert("Url is not valid!"); 
              return false; 
      } ,
        addTag() {
          if(this.tags.length == 5)
          {
             this.$alert("Maximum URLs reached, only 5 competitors can be added ", "Sorry!", "error");
             this.tagValue = '';
             return;
          }
          if(!this.tagValue == '' && this.validate(this.tagValue))
          {
             this.tags.push(this.tagValue);
             this.tagValue = '';
          }
           
          else
          {
            this.$alert("Please enter proper url and try again", "Error", "error");
          }
          
        },
        
        removeTag(index) {
          this.tags.splice(index, 1);
        }
      },
      directives: {
        focus: {
          inserted: (el) => {
            el.focus()
          }
        }
      }
    }
  </script>
  
  <style lang="scss" scoped>
    .tags-input-container {
      width:583px;
      max-width: 583px;
    height:120px;
    border: 1px solid #9597A6;
    border-radius: 5px 5px 5px 5px;
    overflow:scroll;
    overflow-y:scroll;
    overflow-x:scroll;
   
    padding: 8px;
    font-size:12px;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none;  /* IE 10+ */
      &::-webkit-scrollbar {
        background: transparent; /* Chrome/Safari/Webkit */
        width: 0px;
      }
      
      input {
          float:left;
        width:565.4px;
         height:24px;
        
        border: 1px solid #9597A6;
          border-radius: 5px 5px 5px 5px;
          font-size:12px;
          padding: 0 5px;
      }
      input:focus{
       
        outline: none;
      }
      
     
      .tag {
        float: left;
        padding: 2px 10px;
        margin-bottom: 8px;
        background-color: rgb(201, 223, 252);
        border-radius: 8px; 
       
        cursor: pointer;
        &:hover {
          background-color: grey;
          border-radius: 8px;
        } 
        span:first-child {
          margin-right: 2px;
        }  
        svg {
          color: #666;
          &:hover {
            color: #333;
          }
        }     
      }
    }
   
  </style>